var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { messageThreadsApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { useMutation, useQueries, useQuery, useQueryClient } from '@tanstack/react-query';
import Dataloader from 'dataloader';
import { useEffect, useMemo, useRef } from 'react';
import { useRootSheetRow, useSheetRowBranch, useSheetRowsById } from '../sheetRow/sheetRowHooks';
import { useAuth } from '../../providers/AuthProvider';
import { useActiveVersions, useShownVersions } from './versions';
//@ts-ignore
import { getFilterCompoundExpression, getSearchNumberColumnsData, getWithDataCompoundExpression, SheetRowPath, } from '../sheetRow/sheetRow';
import { useActiveYears } from './timePoints';
import { useLocalData } from '../../base/LocalDataContext';
var GENERAL_THREADS_KEY = 'general_threads';
var CLUSTER_THREADS_KEY = 'cluster_threads';
var UNREAD_GENERAL_KEY = 'unread_general_msgs';
var REPLIES_BY_THREAD_ID_KEY = 'replies_by_thread_id';
export function createClusterMessageAnchorPrefix(clusterPath) {
    return "CLUSTER:".concat(clusterPath, "//");
}
export function createMessageAnchorForTableCell(clusterPath, tagIds) {
    return "CLUSTER:".concat(clusterPath, "//IDS:").concat(tagIds.join(','));
}
export function createMessageAnchorForTagCell(clusterPath, tableTagId, tagId) {
    return "CLUSTER:".concat(clusterPath, "//TAGCELL:").concat(tableTagId, ":").concat(tagId);
}
export function getClusterPathFromAnchor(anchor) {
    var pattern = 'CLUSTER:(.*)//';
    var result = anchor.match(pattern);
    return result ? result[1] : '';
}
export function getExtraIdsFromAnchor(anchor) {
    var pattern = 'IDS:(.*?)$';
    var result = anchor.match(pattern);
    var idsString = result ? result[1] : '';
    var ids = idsString.length > 0 ? idsString.split(',').map(function (n) { return parseInt(n); }) : [];
    return ids;
}
function useArrayMemo(array) {
    // this holds reference to previous value
    var ref = useRef();
    // check if each element of the old and new array match
    var areArraysConsideredTheSame = ref.current && array.length === ref.current.length
        ? array.every(function (element, i) {
            return ref.current && element === ref.current[i];
        })
        : //initially there's no old array defined/stored, so set to false
            false;
    useEffect(function () {
        //only update prev results if array is not deemed the same
        if (!areArraysConsideredTheSame) {
            ref.current = array;
        }
    }, [areArraysConsideredTheSame, array]);
    return areArraysConsideredTheSame ? ref.current || [] : array;
}
function fetchMessageThreads(paths) {
    return __awaiter(this, void 0, Promise, function () {
        var shortestPath, pathMap, paths_1, paths_1_1, path, splat, prefix, res, res_1, res_1_1, messageThread, path, threads;
        var e_1, _a, e_2, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    shortestPath = paths[0].split('_');
                    pathMap = new Map();
                    try {
                        for (paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
                            path = paths_1_1.value;
                            splat = path.split('_');
                            if (shortestPath.length > splat.length) {
                                shortestPath = splat;
                            }
                            pathMap.set(path, []);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    prefix = "CLUSTER:".concat(shortestPath.join('_'));
                    return [4 /*yield*/, messageThreadsApi.list(1000, prefix)];
                case 1:
                    res = _c.sent();
                    try {
                        for (res_1 = __values(res), res_1_1 = res_1.next(); !res_1_1.done; res_1_1 = res_1.next()) {
                            messageThread = res_1_1.value;
                            if (!messageThread.anchor) {
                                continue;
                            }
                            path = getClusterPathFromAnchor(messageThread.anchor);
                            threads = pathMap.get(path);
                            if (threads) {
                                threads.push(messageThread);
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (res_1_1 && !res_1_1.done && (_b = res_1.return)) _b.call(res_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [2 /*return*/, Array.from(pathMap.values())];
            }
        });
    });
}
var messageThreadLoader = new Dataloader(fetchMessageThreads, {
    cache: false,
});
export function useGeneralComments() {
    var data = useQuery([GENERAL_THREADS_KEY], function () { return messageThreadsApi.list(1000, undefined, undefined, undefined); }, {
        staleTime: Infinity,
    }).data;
    var arr = useMemo(function () {
        return data || [];
    }, [data]);
    return arr;
}
export function useMessageThreadsByAnchor() {
    var userSettings = useAuth().settings;
    var tagData = useTagContext().tagData;
    var activeYears = useActiveYears();
    var rootSheetRow = useRootSheetRow();
    var activeVersions = useActiveVersions();
    var sheetRowsById = useSheetRowsById();
    var shownVersions = useShownVersions(userSettings);
    var _a = useLocalData(), filterTagIds = _a.filterTagIds, withDataMap = _a.withDataMap;
    var filterCompoundExpression = getFilterCompoundExpression(filterTagIds, tagData.tagById);
    var withDataCompoundExpression = getWithDataCompoundExpression(userSettings.model_table_timeline_versions_by_year, { start: userSettings.model_table_interval_start, end: userSettings.model_table_interval_end }, activeYears, tagData.tagById, tagData.internalTagsMap, shownVersions, activeVersions);
    var numberColumnsData = getSearchNumberColumnsData(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow);
    var path = useMemo(function () {
        return (rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.path) ? new SheetRowPath(rootSheetRow.path) : new SheetRowPath('0');
    }, [rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.path]);
    var _b = __read(useSheetRowBranch(path, tagData.tagById, sheetRowsById, userSettings.expanded_clusters, {
        withDataCompoundExpression: withDataCompoundExpression,
        filterCompoundExpression: filterCompoundExpression,
    }, withDataMap, numberColumnsData), 1), sheetRows = _b[0];
    var paths = sheetRows.map(function (sheetRow) { return sheetRow.path; });
    var queries = useMemo(function () {
        return paths.map(function (path) {
            return {
                queryKey: [CLUSTER_THREADS_KEY, path],
                queryFn: function () { return messageThreadLoader.load(path); },
                staleTime: Infinity,
                notifyOnChangeProps: ['data'],
            };
        });
    }, [paths]);
    var result = useQueries({ queries: queries });
    var res = useArrayMemo(result.map(function (r) { return r.data; }));
    return useMemo(function () {
        var e_3, _a, e_4, _b;
        var messageThreadMap = new Map();
        try {
            for (var res_2 = __values(res), res_2_1 = res_2.next(); !res_2_1.done; res_2_1 = res_2.next()) {
                var r = res_2_1.value;
                if (!r) {
                    continue;
                }
                try {
                    for (var r_1 = (e_4 = void 0, __values(r)), r_1_1 = r_1.next(); !r_1_1.done; r_1_1 = r_1.next()) {
                        var messageThread = r_1_1.value;
                        if (!messageThread.anchor) {
                            continue;
                        }
                        var threads = messageThreadMap.get(messageThread.anchor);
                        if (!threads) {
                            threads = [];
                            messageThreadMap.set(messageThread.anchor, threads);
                        }
                        threads.push(messageThread);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (r_1_1 && !r_1_1.done && (_b = r_1.return)) _b.call(r_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (res_2_1 && !res_2_1.done && (_a = res_2.return)) _a.call(res_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return messageThreadMap;
    }, [res]);
}
export function useRepliesByMessageThreadId(threadId) {
    var data = useQuery([REPLIES_BY_THREAD_ID_KEY, threadId], function () { return messageThreadsApi.listMessages(threadId, 1000); }, {
        staleTime: Infinity,
    }).data;
    return data || [];
}
export function useUnreadCommentsNumber(path) {
    var _this = this;
    var queryClient = useQueryClient();
    var data = useQuery([UNREAD_GENERAL_KEY], function () { return __awaiter(_this, void 0, void 0, function () {
        var previousCount, r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    previousCount = queryClient.getQueryData([UNREAD_GENERAL_KEY]);
                    return [4 /*yield*/, messageThreadsApi.countUnread()];
                case 1:
                    r = _a.sent();
                    if (previousCount !== undefined && Number.isInteger(previousCount) && r.count > previousCount) {
                        queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
                        queryClient.invalidateQueries([CLUSTER_THREADS_KEY]);
                        queryClient.invalidateQueries([REPLIES_BY_THREAD_ID_KEY]);
                    }
                    return [2 /*return*/, r.count];
            }
        });
    }); }, {
        refetchInterval: 5000,
        staleTime: 5000,
    }).data;
    return data || 0;
}
export function useCommentsActions() {
    var queryClient = useQueryClient();
    var removeMessageThread = useMutation(function (thread) {
        return messageThreadsApi._delete(thread.id);
    }, {
        onSettled: function (data, err, vars) {
            if (vars.anchor) {
                var clusterPath = getClusterPathFromAnchor(vars.anchor);
                queryClient.invalidateQueries([CLUSTER_THREADS_KEY, clusterPath]);
            }
            queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
        },
    });
    var addMessageThread = useMutation(function (variables) {
        var _a, _b, _c;
        return messageThreadsApi.create(JSON.stringify(variables.message), ((_a = variables === null || variables === void 0 ? void 0 : variables.files) === null || _a === void 0 ? void 0 : _a.length) === 1 ? variables === null || variables === void 0 ? void 0 : variables.files[0] : undefined, ((_c = (_b = variables === null || variables === void 0 ? void 0 : variables.files) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 1 ? variables === null || variables === void 0 ? void 0 : variables.files : undefined);
    }, {
        onSettled: function (data, err, vars) {
            if (vars.message.anchor) {
                var clusterPath = getClusterPathFromAnchor(vars.message.anchor);
                queryClient.invalidateQueries([CLUSTER_THREADS_KEY, clusterPath]);
            }
            queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
        },
    });
    var appendMessageToThread = useMutation(function (_a) {
        var _b;
        var threadId = _a.threadId, message = _a.message, _c = _a.files, files = _c === void 0 ? [] : _c;
        return messageThreadsApi.appendMessage(threadId, JSON.stringify(message), (files === null || files === void 0 ? void 0 : files.length) === 1 ? files[0] : undefined, ((_b = files === null || files === void 0 ? void 0 : files.length) !== null && _b !== void 0 ? _b : 0) > 1 ? files : undefined);
    }, {
        onSettled: function (data, err, vars) {
            queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
            if (vars.anchor) {
                var clusterPath = getClusterPathFromAnchor(vars.anchor);
                queryClient.invalidateQueries([CLUSTER_THREADS_KEY, clusterPath]);
            }
            queryClient.invalidateQueries([REPLIES_BY_THREAD_ID_KEY, vars.threadId]);
        },
    });
    var changeCommentStatus = useMutation(function (_a) {
        var messageThread = _a.messageThread, status = _a.status;
        return messageThreadsApi.setMessageStatus(messageThread.id, 1, { status: status });
    }, {
        onSettled: function (data, err, vars) {
            queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
            if (vars.messageThread.anchor) {
                var clusterPath = getClusterPathFromAnchor(vars.messageThread.anchor);
                queryClient.invalidateQueries([CLUSTER_THREADS_KEY, clusterPath]);
            }
        },
    });
    var readComment = useMutation(function (_a) {
        var messageThread = _a.messageThread, lastMessageOrder = _a.lastMessageOrder;
        return messageThreadsApi.setCursor(messageThread.id, { position: lastMessageOrder });
    }, {
        onSettled: function (data, err, obj) {
            queryClient.invalidateQueries([GENERAL_THREADS_KEY]);
            queryClient.invalidateQueries([UNREAD_GENERAL_KEY]);
            if (obj.messageThread.anchor) {
                var clusterPath = getClusterPathFromAnchor(obj.messageThread.anchor);
                queryClient.invalidateQueries([CLUSTER_THREADS_KEY, clusterPath]);
            }
        },
    });
    return {
        addMessageThread: addMessageThread.mutateAsync,
        appendMessageToThread: appendMessageToThread.mutateAsync,
        changeCommentStatus: changeCommentStatus.mutateAsync,
        readComment: readComment.mutateAsync,
        removeMessageThread: removeMessageThread.mutateAsync,
        isAddingMessageThread: addMessageThread.isLoading,
        isAppendingMessageThread: appendMessageToThread.isLoading,
    };
}
